import React, {useState, useEffect, useRef} from 'react';

import {Image} from 'react-bootstrap';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
    faTimes,
    faUserGroup,
    faLightbulb,
    faRocket,
    faPlay,faMoneyBill1Wave
} from '@fortawesome/free-solid-svg-icons';
import './homePopup.css';

// 直播预约弹窗组件
const HomePopup = ({isVisible, onClose}) => {
    const popupRef = useRef(null);
    const [liveQrCode, setLiveQrCode] = useState('');
    const [liveLoading, setLiveLoading] = useState(true);

    useEffect(() => {
        if (isVisible) {
            document.body.style.overflow = 'hidden';
            // 获取直播预约二维码
            fetchLiveQrCode();
        } else {
            document.body.style.overflow = '';
        }

        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                onClose();
            }
        };

        if (isVisible) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.body.style.overflow = '';
        };
    }, [isVisible, onClose]);

    const fetchLiveQrCode = () => {

        // 设置默认图片
        setLiveQrCode('/images/wx_group.png');
        setLiveLoading(false);

    };

    const handleDismissTodayClick = () => {
        // 保存当前日期到 localStorage
        const today = new Date().toISOString().split('T')[0];
        localStorage.setItem('livestream_popup_dismissed_date', today);
        onClose();
    };

    if (!isVisible) return null;

    return (
        <div className="livestream-popup-overlay">
            <div className="livestream-popup" ref={popupRef}>
                <button className="livestream-popup-close" onClick={onClose}>
                    <FontAwesomeIcon icon={faTimes}/>
                </button>
                <div className="livestream-popup-content">
                    <div className="livestream-popup-header">
                        <div className="livestream-popup-badge">
                            <FontAwesomeIcon icon={faUserGroup} style={{marginRight: '0.5rem'}}/>
                            <span> 沸推AIGC官方群聊</span>
                        </div>
                        <h2 className="livestream-popup-title">
                            <span className="livestream-title-highlight">扫码加入官方交流群</span>
                        </h2>
                    </div>
                    <div className="livestream-center-qrcode">
                        <div className="livestream-qrcode-spotlight">
                            <div className="livestream-wealth-decoration"><FontAwesomeIcon icon={faMoneyBill1Wave}/>
                            </div>
                            <div className="livestream-qrcode-container-enhanced">
                                {liveLoading ? (
                                    <div className="livestream-loading-spinner-enhanced">
                                        <div className="livestream-loading-ring"></div>
                                        <div className="livestream-loading-text">加载中...</div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="livestream-qrcode-frame">
                                            <img
                                                src={liveQrCode}
                                                alt="扫码预约直播"
                                                className="livestream-qrcode-image-enhanced"
                                            />
                                            <div className="livestream-qrcode-glow-ring"></div>
                                            <div className="livestream-qrcode-pulse-ring"></div>
                                        </div>
                                        <div className="livestream-qrcode-scan-hint-enhanced">
                                            <div className="livestream-wechat-icon-wrapper">
                                                <img
                                                    src="/images/weixin_icon_2.png"
                                                    alt="微信"
                                                    className="livestream-wechat-icon-enhanced"
                                                />
                                            </div>
                                            <span className="livestream-scan-text">微信扫码加群</span>
                                        </div>
                                    </>
                                )}
                                <div className="livestream-scan-line-enhanced"></div>
                                <div className="livestream-corner-enhanced livestream-corner-1"></div>
                                <div className="livestream-corner-enhanced livestream-corner-2"></div>
                                <div className="livestream-corner-enhanced livestream-corner-3"></div>
                                <div className="livestream-corner-enhanced livestream-corner-4"></div>
                            </div>
                            <div className="livestream-qrcode-cta">
                                <p className="livestream-qrcode-text-enhanced">
                                    <span className="livestream-cta-icon">📢</span>
                                    官方交流群，一起学习AIGC
                                    <span className="livestream-cta-icon">🚀</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="livestream-popup-body-enhanced">
                        <div className="livestream-benefits-grid">
                            <div className="livestream-benefit-enhanced">
                                {/*<FontAwesomeIcon icon={faLightbulb} className="livestream-benefit-icon-enhanced"/>*/}
                                <Image src="/images/home/popup_tag_1.svg" className="livestream-benefit-icon-enhanced" />
                                <div className="livestream-benefit-content-enhanced">
                                    <h4>学习资料分享</h4>
                                    <p>获取官方AIGC学习资料，第一时间掌握最新技术动态</p>
                                </div>
                            </div>
                            <div className="livestream-benefit-enhanced">
                                {/*<FontAwesomeIcon icon={faRocket} className="livestream-benefit-icon-enhanced"/>*/}
                                <Image src="/images/home/popup_tag_2.svg" className="livestream-benefit-icon-enhanced" />
                                <div className="livestream-benefit-content-enhanced">
                                    <h4>技术交流</h4>
                                    <p>与AIGC爱好者一起交流学习，分享使用心得</p>
                                </div>
                            </div>
                            <div className="livestream-benefit-enhanced">
                                {/*<FontAwesomeIcon icon={faPlay} className="livestream-benefit-icon-enhanced"/>*/}
                                <Image src="/images/home/popup_tag_3.svg" className="livestream-benefit-icon-enhanced" />
                                <div className="livestream-benefit-content-enhanced">
                                    <h4>问题解答</h4>
                                    <p>官方技术支持，快速解决使用中遇到的问题</p>
                                </div>
                            </div>
                        </div>
                        <button className="livestream-dismiss-btn-enhanced" onClick={handleDismissTodayClick}>
                            今日不再提醒
                            <div className="livestream-btn-glow-enhanced"></div>
                        </button>
                    </div>
                </div>
                <div className="livestream-decorations">
                    <div className="livestream-decoration livestream-decoration-1"></div>
                    <div className="livestream-decoration livestream-decoration-2"></div>
                    <div className="livestream-decoration livestream-decoration-3"></div>
                    <div className="livestream-particles">
                        {[...Array(15)].map((_, i) => (
                            <div key={i} className={`livestream-particle livestream-particle-${i + 1}`}></div>
                        ))}
                    </div>
                    <div className="livestream-glow livestream-glow-1"></div>
                    <div className="livestream-glow livestream-glow-2"></div>
                </div>
            </div>
        </div>
    );
};

export default HomePopup;